<template>
    <div v-if="localShow" role="alert" :class="classObject" @animationend="animationEndDismiss">{{message}}</div>
</template>

<script>
    export default {
        name: "Notification",

        props: {
            show: {
                type: [Boolean, Number],
                default: false
            },
            message: {
                type: String,
                default: ''
            },
            variant: {
                type: String,
                default: 'info'
            },
            dismissible: {
                type: Boolean,
                default: false
            },
            autoDismiss: {
                type: Boolean,
                default: false
            },
        },

        data: () => ({
            dismissed: false
        }),

        computed: {
            classObject () {
                return ['notification', this.alertVariant, this.dismissible ? 'dismissible' : '', this.autoDismiss ? 'has-countdown' : '']
            },
            alertVariant () {
                const variant = this.variant
                return variant
            },
            localShow() {
                return !this.dismissed && this.show;
            }
        },

        watch: {
            show() {
                this.showChanged();
            }
        },

        methods: {
            dismiss() {
                this.dismissed = true;
                this.$emit('dismissed');
            },
            showChanged() {
                this.dismissed = false;
            },
            animationEndDismiss(e) {
                this.autoDismiss && e.animationName.includes('toast') || e.animationName.includes('notification') ? this.dismiss() : '';
            }
        },
    };
</script>
